import { useState, useContext, useEffect } from "react";
import axios from "axios";
import { AuthContext } from "../../../../../contexts/AuthContext";
import "./MaqPagamentosCliente.css";
import CustomDateRangePicker from "../CustomDatePicker/CustomRangePicker";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import * as links from "../../../../../utils/links";
import moment from "moment";
import PagamentosTable from "../Table/PagamentosTable";
import Swal from "sweetalert2";
import jsPDF from "jspdf";

export default function MaqPagamentosCliente() {

  const location = useLocation();
  const locationState = location.state || {};
  const [maquinaInfos, setMaquinaInfos] = useState(locationState || {});

  const { setDataUser, authInfo, setNotiMessage } = useContext(AuthContext);
  const { dataUser } = authInfo;

  let navigate = useNavigate();
  const token = authInfo?.dataUser?.token;
  const [estornos, setEstornos] = useState("");
  const [loadingTable, setLoadingTable] = useState(false);
  const [listCanals, setListCanals] = useState([]);
  const [estoque, setEstoque] = useState("");
  const [dataInicio, setDataInicio] = useState(locationState?.dataInicio || null);
  const [dataFim, setDataFim] = useState(locationState?.dataFim || null);
  const [cash, setCash] = useState("");
  const [total, setTotal] = useState("");
  // Novos estados para alinhar com Relatório
  const [taxas, setTaxas] = useState({ PIX: 0, CREDITO: 0, DEBITO: 0 });
  const [pagamentosAgg, setPagamentosAgg] = useState({ PIX: 0, CREDITO: 0, DEBITO: 0, ESPECIE: 0 });
  const [totais, setTotais] = useState({ especie: 0, pix: 0, debito: 0, credito: 0, quantidade: 0, totalGeral: 0, totalGeralEstornos: 0, totalBruto: 0, totalLiquido: 0, estornos: 0 });

  const { id } = useParams();

  useEffect(() => {
    if (!id?.trim()) return;
    if ((dataInicio && !dataFim) || (!dataInicio && dataFim)) return;
    if (dataInicio && dataFim) {
      getPaymentsPeriod(dataInicio, dataFim);
      return;
    }
    getData(id);
  }, [id, dataInicio, dataFim]);

  // Helper para normalizar tipo e agregar pagamentos
  const normalizeTipo = (tipo) => {
    const tipoValue = String(tipo || "").trim().toLowerCase();
    return tipoValue === "bank_transfer" || tipoValue === "11" || tipoValue === "account_money" || tipoValue === "conta mercado pago" || tipoValue === "pix"
      ? "PIX"
      : tipoValue === "cash"
        ? "ESPECIE"
        : tipoValue === "debit_card" || tipoValue === "8"
          ? "DEBITO"
          : tipoValue === "credit_card" || tipoValue === "prepaid_card" || tipoValue === "1"
            ? "CREDITO"
            : tipoValue === "saiu premio"
              ? "PREMIO"
              : null;
  };

  const aggregatePayments = (pagamentos, cashApi, preferCashApi = false) => {
    const sums = { PIX: 0, CREDITO: 0, DEBITO: 0, ESPECIE: 0 };
    if (Array.isArray(pagamentos)) {
      pagamentos.forEach((p) => {
        const t = normalizeTipo(p?.tipo);
        const valor = Number(p?.valor) || 0;
        if (t && t !== "PREMIO") {
          if (t === "ESPECIE") sums.ESPECIE += valor;
          else if (t === "PIX") sums.PIX += valor;
          else if (t === "CREDITO") sums.CREDITO += valor;
          else if (t === "DEBITO") sums.DEBITO += valor;
        }
      });
    }
    // Só usa o valor de espécie da API quando explicitamente preferido
    if (preferCashApi && typeof cashApi === "number") {
      sums.ESPECIE = cashApi;
    }
    return sums;
  };

  const isSaidaPremio = (t) => {
    const idStr = t?.mercadoPagoId ? String(t.mercadoPagoId).toLowerCase() : "";
    return idStr.includes("saiu premio") || normalizeTipo(t?.tipo) === "SAIDA_PRODUTO";
  };

  const parseSaidaQuantidade = (t) => {
    const s = String(t?.operadora || "");
    const m = s.match(/Saiu\s+(\d+)/i);
    if (m && m[1]) return Number(m[1]) || 1;
    return 1;
  };

  const filtrarPagamentosPorPeriodo = (pagamentos = [], inicio, fim) => {
    if (!Array.isArray(pagamentos)) return [];
    if (!inicio || !fim) return pagamentos;

    const dataInicial = moment(inicio).startOf("day");
    const dataFinal = moment(fim).endOf("day");

    return pagamentos.filter((pagamento) => {
      if (!pagamento?.data) return false;
      const dataPagamento = moment(pagamento.data);
      return dataPagamento.isValid() && dataPagamento.isBetween(dataInicial, dataFinal, undefined, "[]");
    });
  };

  const premiosEntregues = Array.isArray(listCanals)
    ? listCanals.reduce((acc, t) => (isSaidaPremio(t) ? acc + parseSaidaQuantidade(t) : acc), 0)
    : 0;

  // useEffect(() => {
  //   const pix = Number(pagamentosAgg.PIX) || 0;
  //   const credito = Number(pagamentosAgg.CREDITO) || 0;
  //   const debito = Number(pagamentosAgg.DEBITO) || 0;
  //   const especie = dataFim != null ? (Number(pagamentosAgg.ESPECIE) || 0) : (typeof cash === "number" ? cash : (Number(pagamentosAgg.ESPECIE) || 0));
  //   const quantidade = Array.isArray(listCanals) ? listCanals.filter((t) => isSaidaPremio(t)).length : 0;
  //   const totalGeral = pix + credito + debito + especie;
  //   setTotais({ especie, pix, debito, credito, quantidade, totalGeral });
  // }, [pagamentosAgg, cash, dataFim, listCanals]);

  const getPaymentsPeriod = (dataInicio, dataFim) => {
    if (id.trim() !== "") {
      setLoadingTable(true);
      const url = `${process.env.REACT_APP_SERVIDOR}/pagamentos-periodo/${id}`;

      let dataInicioISO = null;
      let dataFimISO = null;

      if (dataInicio) {
        // dataInicioISO = moment(dataInicio).startOf("day").toISOString();
        dataInicioISO = `${moment(dataInicio).format('YYYY-MM-DD')}T03:00:00.000Z`;
      }

      if (dataFim) {
        // dataFimISO = moment(dataFim).toISOString();
        const dataFimObj = new Date(dataFim);
        dataFimObj.setDate(dataFimObj.getDate() + 1);
        dataFimISO = `${dataFimObj.toISOString().split("T")[0]}T02:59:59.999Z`;
      }

      const requestBody = {};

      if (dataInicioISO) requestBody.dataInicio = dataInicioISO;
      if (dataFimISO) requestBody.dataFim = dataFimISO;


      axios
        .post(
          url,
          requestBody,
          {
            headers: {
              "x-access-token": token,
              "content-type": "application/json",
            },
          }
        )
        .then((res) => {
          setLoadingTable(false);
          setEstornos(res.data.estornos);
          setCash(res?.data?.cash);
          setTotal(res.data.total);
          setTotais({
            credito: res.data.totalCartaoCredito,
            debito: res.data.totalCartaoDebito,
            pix: res.data.totalPix,
            especie: res.data.cash,
            quantidade: res.data.qtd,
            totalGeral: res.data.total,
            totalGeralEstornos: res.data.estornos,
            totalBruto: res.data.totalBruto,
            totalLiquido: res.data.totalLiquido,
            estornos: res.data.estornos
          })
          setTaxas({
            CREDITO: res.data.taxaCartaoCredito,
            DEBITO: res.data.taxaCartaoDebito,
            PIX: res.data.taxaPix
          })
          if (res.status === 200 && Array.isArray(res.data.pagamentos)) {
            // setListCanals(filtrarPagamentosPorPeriodo(res.data.pagamentos, dataInicio, dataFim));
            setListCanals(res.data.pagamentos)
            // No filtro por período, calcular espécie apenas a partir dos pagamentos
            // setPagamentosAgg(aggregatePayments(res.data.pagamentos, res?.data?.cash, false));

          }
          // Buscar taxas e estornos agregados como no Relatório
          const bodyRel = {
            maquinaId: id,
            ...(dataInicioISO ? { dataInicio: new Date(dataInicioISO) } : {}),
            ...(dataFimISO ? { dataFim: new Date(dataFimISO) } : {}),
          };
          Promise.all([
            axios.post(`${process.env.REACT_APP_SERVIDOR}/relatorio-02-taxas`, bodyRel, {
              headers: {
                "x-access-token": token,
                "content-type": "application/json",
              },
            }),
            axios.post(`${process.env.REACT_APP_SERVIDOR}/relatorio-04-estornos`, bodyRel, {
              headers: {
                "x-access-token": token,
                "content-type": "application/json",
              },
            }),
          ])
            .then(([taxasVal, estornosVal]) => {
              setTaxas({
                PIX: taxasVal?.data?.pix || 0,
                CREDITO: taxasVal?.data?.credito || 0,
                DEBITO: taxasVal?.data?.debito || 0,
              });
              if (typeof estornosVal?.data?.valor === "number") {
                setEstornos(estornosVal.data.valor);
              }
            })
            .catch(() => {
              // Silenciar erro de taxas/estornos para não bloquear UI
            });
        })
        .catch((err) => {
          setLoadingTable(false);
          if ([401, 403].includes(err.response.status)) {
            setNotiMessage({
              type: "error",
              message:
                "A sua sessão expirou, para continuar faça login novamente.",
            });
            if (dataUser.key === 'ADMIN') {
              navigate(links.ADMIN_SIGNIN);
              setDataUser(null);
            } else {
              navigate(links.SIGNIN);
              setDataUser(null);
            }
          }
        });
    }
  };

  const getData = (id) => {
    if (id.trim() !== "") {
      setLoadingTable(true);
      axios
        .get(`${process.env.REACT_APP_SERVIDOR}/pagamentos/${id}`, {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        })
        .then((res) => {
          setLoadingTable(false);
          setEstornos(res.data.estornos);
          setCash(res?.data?.cash);
          setEstoque(res?.data?.estoque);
          setTotal(res.data.total);
          setMaquinaInfos(prev => ({
            ...prev,
            store_id: res.data.store_id || prev.store_id
          }));
          setTotais({
            credito: res.data.totalCartaoCredito,
            debito: res.data.totalCartaoDebito,
            pix: res.data.totalPix,
            especie: res.data.cash,
            quantidade: res.data.qtd,
            totalGeral: res.data.total,
            totalGeralEstornos: res.data.estornos,
            totalBruto: res.data.totalBruto,
            totalLiquido: res.data.totalLiquido,
            estornos: res.data.estornos
          })
          setTaxas({
            CREDITO: res.data.taxaCartaoCredito,
            DEBITO: res.data.taxaCartaoDebito,
            PIX: res.data.taxaPix
          })
          if (res.status === 200 && Array.isArray(res.data.pagamentos)) {
            setListCanals(res.data.pagamentos);
          }
        })
        .catch((err) => {
          setLoadingTable(false);
          if ([401, 403].includes(err.response.status)) {
            setNotiMessage({
              type: "error",
              message:
                "A sua sessão expirou, para continuar faça login novamente.",
            });
            if (dataUser.key === 'ADMIN') {
              navigate(links.ADMIN_SIGNIN)
              setDataUser(null);
            } else {
              navigate(links.SIGNIN)
              setDataUser(null);
            }
          }
        });
    }
  };

  const removerPagamento = async (item) => {
    Swal.fire({
      title: "Alerta",
      text:`Deseja remover o pagamento ${item?.mercadoPagoId}? Caso sim, este pagamento não será mais recuperado`,
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Sim",
      denyButtonText: `Não`
    }).then((result) => {
      if (result.isConfirmed) {
        mensagemLoading('Removendo pagamento..')
        axios.delete(`${process.env.REACT_APP_SERVIDOR}/delete-pagamento-cliente/${item.id}`, {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        }).then((res) => {
          mensagemSucesso('Pagamento removido com sucesso')
        }).catch((err) => {
          mensagemErro('Erro ao remover pagamento')
        });
      }
    });
  };

  const onRelatorioHandler = () => {
    if (!dataInicio || !dataFim) {
      setNotiMessage({
        type: "error",
        message:
          "Selecione no calendário a data de início e fim para gerar o relatório para essa maquina!",
      });
    } else {
      navigate(`${links.RELATORIO}/${id}`, {
        state: { maquinaInfos, dataInicio, dataFim },
      });
    }
  };

  const onRelatorioDispHandler = () => {
    if (!dataInicio || !dataFim) {
      setNotiMessage({
        type: "error",
        message:
          "Selecione no calendário a data de início e fim para gerar o relatório para essa maquina!",
      });
    } else {
      navigate(`${links.RELATORIO_DISP}/${id}`, {
        state: { maquinaInfos, dataInicio, dataFim },
      });
    }
  };

  function mensagemAlerta(msg) {
    Swal.fire('Alerta', msg, 'warning')
  }
  function mensagemSucesso(msg) {
    Swal.fire('Sucesso', msg, 'success').then(() => {
      setListCanals([])
      getData(id);
    })
  }
  function mensagemErro(msg) {
    Swal.fire('Erro', msg, 'error')
  }
  function mensagemLoading(msg) {
    Swal.fire({
      title: 'Aguarde',
      html: msg,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })
  }

  const exportarPagamentoPdf = async (item) => {
    if (!item?.id) return;

    const isObject = (v) => v !== null && typeof v === "object";

    const toPrintable = (v) => {
      if (v === undefined || v === null) return "-";
      if (typeof v === "string") return v.trim() === "" ? "-" : v;
      if (typeof v === "number") return Number.isFinite(v) ? String(v) : "-";
      if (typeof v === "boolean") return v ? "true" : "false";
      try {
        if (v instanceof Date) return moment(v).format("DD/MM/YYYY HH:mm:ss");
      } catch (_) { }
      if (isObject(v)) {
        try {
          return JSON.stringify(v);
        } catch (_) {
          return String(v);
        }
      }
      return String(v);
    };

    const flatten = (obj, prefix = "", out = []) => {
      if (!isObject(obj)) return out;
      if (Array.isArray(obj)) {
        obj.forEach((item, idx) => {
          const nextPrefix = prefix ? `${prefix}[${idx}]` : `[${idx}]`;
          if (isObject(item)) flatten(item, nextPrefix, out);
          else out.push({ key: nextPrefix, value: item });
        });
        return out;
      }

      Object.keys(obj).sort().forEach((k) => {
        const v = obj[k];
        const nextPrefix = prefix ? `${prefix}.${k}` : k;
        if (isObject(v)) flatten(v, nextPrefix, out);
        else out.push({ key: nextPrefix, value: v });
      });
      return out;
    };

    try {
      mensagemLoading("Gerando PDF...");
      const res = await axios.get(
        `${process.env.REACT_APP_SERVIDOR}/pagamento-detalhe/${item.id}`,
        {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        }
      );
      Swal.close();

      const detalhe = res?.data || {};
      const p = detalhe?.pagamento || {};
      const mp = detalhe?.mercadopago || {};

      const doc = new jsPDF();
      let y = 14;

      const addLine = (label, value) => {
        const text = `${label}: ${toPrintable(value)}`;
        const lines = doc.splitTextToSize(text, 190);
        for (const line of lines) {
          if (y > 285) {
            doc.addPage();
            y = 14;
          }
          doc.text(line, 10, y);
          y += 7;
        }
      };

      const addTitle = (title) => {
        if (y > 275) {
          doc.addPage();
          y = 14;
        }
        doc.setFontSize(12);
        doc.text(title, 10, y);
        y += 8;
        doc.setFontSize(10);
      };

      doc.setFontSize(14);
      doc.text("Comprovante de Pagamento (Sistema)", 10, y);
      y += 10;
      doc.setFontSize(10);

      addTitle("Resumo");
      addLine("ID Interno", p?.id);
      addLine("ID Mercado Pago", p?.mercadoPagoId ?? mp?.id);
      addLine("Data", p?.data ? moment(p?.data).format("DD/MM/YYYY HH:mm:ss") : "-");
      addLine("Tipo", p?.tipo);
      addLine("Valor", new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(p?.valor || 0)));
      addLine("Taxas", new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(p?.taxas || 0)));
      addLine("Estornado", p?.estornado ? "Sim" : "Não");
      addLine("Motivo do Estorno", p?.motivoEstorno);
      addLine("Status (Sistema)", p?.status);
      addLine("Liberação do Produto (Sistema)", String(p?.status || "").toUpperCase() === "CONFIRMADO" ? "Sim" : "Não");
      addLine("Bônus (Sistema)", p?.valorBonus);

      addTitle("Detalhes (Pagamento)");
      flatten(p)
        .filter(({ key }) => {
          const rootKey = String(key).split(".")[0];
          return rootKey !== "maquina" && rootKey !== "cliente";
        })
        .forEach(({ key, value }) => addLine(key, value));

      if (mp && Object.keys(mp).length > 0) {
        addTitle("Detalhes (Mercado Pago)");
        flatten(mp).forEach(({ key, value }) => addLine(key, value));
      }

      const fileId = p?.mercadoPagoId || mp?.id || item?.mercadoPagoId || item?.id;
      doc.save(`pagamento-${fileId}.pdf`);
    } catch (err) {
      try {
        Swal.close();
      } catch (_) { }
      mensagemErro("Erro ao gerar PDF");
    }
  };

  return (
    <div className="MaqPagamentos_container container mw-100">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="h4 fw-bold">{maquinaInfos?.nome}</h1>
        <div className="d-flex col-6 col-md-auto mb-2">
          <button className="custom-btn btn btn-outline-secondary"
            onClick={() =>
              navigate(`${links.DASHBOARD_FORNECEDOR}`)
            }>VOLTAR</button>
        </div>
      </div>
      <div className="d-flex justify-content-start align-items-center mb-4">
        <div className="d-flex flex-wrap">
          <CustomDateRangePicker
            setDataFim={setDataFim}
            setDataInicio={setDataInicio}
            value={{ dataInicio, dataFim }}
          />
          {authInfo?.dataUser.key != 'FUNCIONARIO' ?
            <>
              <div className="d-flex col-7 col-md-auto">
                <button className="custom-btn btn btn-outline-primary d-flex w-100 mb-2"
                  onClick={() => {
                    navigate(`${links.EDIT_FORNECEDOR_CANAIS}/${id}`, {
                      state: location.state,
                    });
                  }}>
                  <i className="bi bi-pencil" style={{ marginRight: '5px' }}></i>
                  Editar Máquina
                </button>
              </div>
              <div className="d-flex col-7 col-md-auto">
                <button className="custom-btn btn btn-outline-primary d-flex w-100 mb-2" onClick={() => {
                  navigate(links.REMOTE_CREDIT.replace(":id", id), {
                    state: location.state,
                  });
                }}>
                  <i className="bi bi-credit-card" style={{ marginRight: '5px' }}></i> Crédito Remoto
                </button>
              </div>
              <div className="d-flex col-7 col-md-auto">
                <button
                  className="custom-btn btn btn-outline-primary d-flex w-100 mb-2"
                  onClick={() => {
                    const url = `https://www.mercadopago.com.br/stores/detail?store_id=${maquinaInfos.store_id}`;
                    window.open(url, '_blank');
                  }}
                >
                  <i className="bi bi-qr-code" style={{ marginRight: '10px' }}></i>
                  QR Code
                </button>
              </div>
            </>
            :
            null
          }

          <div className="d-flex col-7 col-md-auto">
            <button className="custom-btn btn btn-outline-primary d-flex w-100 mb-2" onClick={() => onRelatorioHandler()}>
              <i className="bi bi-file-earmark-text" style={{ marginRight: '10px' }}></i>
              Rel. de Pagamentos
            </button>
          </div>
          <div className="d-flex col-7 col-md-auto">
            <button className="custom-btn btn btn-outline-primary d-flex w-100 mb-2" onClick={() => onRelatorioDispHandler()}>
              <i className="bi bi-file-bar-graph" style={{ marginRight: '10px' }}></i>
              Rel. de Disponibilidade
            </button>
          </div>
          {/* <div className="d-flex col-7 col-md-auto">
            <button className="custom-btn btn btn-outline-primary d-flex w-100 mb-2"
            onClick={() => {
              navigate(`${links.CLIENTES_MAQUINAS_TROCAR}/${id}`, {
                state: location.state,
              });
            }}>
            <i className="bi bi-arrow-counterclockwise" style={{marginRight: '10px'}}></i>
              Trocar ID
            </button>
          </div> */}
          {authInfo?.dataUser.key != 'FUNCIONARIO' ?
            <div className="d-flex col-7 col-md-auto">
              <button className="custom-btn btn btn-outline-danger d-flex w-100 mb-2"
                onClick={() => {
                  navigate(`${links.DELETE_FORNECEDOR_CANAIS}/${id}`, {
                    state: location.state,
                  });
                }}>
                <i className="bi bi-trash" style={{ marginRight: '5px' }}></i>
                Excluir Pagamentos
              </button>
            </div>
            :
            null
          }

        </div>
      </div>


      {/* Filtros */}
      {/* <div className="d-flex justify-content-start align-items-center mb-4">
        <div className="d-flex flex-wrap gap-2">
          <CustomDateRangePicker/>
          <div className="d-flex col-6 col-md-auto">
            <input type="date" className="form-control w-100 mb-2" />
          </div>
          <div className="d-flex col-6 col-md-auto">
            <button className="custom-btn btn btn-outline-primary w-100 mb-2">Rel. de Pagamentos</button>
          </div>
          <div className="d-flex col-6 col-md-auto">
            <button className="custom-btn btn btn-outline-primary w-100 mb-2">Rel. de Disponibilidade</button>
          </div>
        </div>
      </div> */}


      {/* Bloco Estornos removido conforme solicitação */}

      {/* Resumo abaixo das Taxas e Estornos */}
      <div className="row mb-4">
        <div className="col-12">
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            <div className="card-total">
              <span className="card-total-title card-total-title-primary"><i className="bi bi-cash-stack card-total-icon"></i>Espécie</span>
              <span className="card-total-value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(totais.especie)}</span>
            </div>
            <div className="card-total">
              <span className="card-total-title card-total-title-primary"><i className="bi bi-qr-code card-total-icon"></i>PIX</span>
              <span className="card-total-value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(totais.pix)}</span>
              <div className="card-total-tax">Taxa: {Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(taxas.PIX || 0)}</div>
            </div>
            <div className="card-total">
              <span className="card-total-title card-total-title-primary"><i className="bi bi-credit-card card-total-icon"></i>Débito</span>
              <span className="card-total-value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(totais.debito)}</span>
              <div className="card-total-tax">Taxa: {Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(taxas.DEBITO || 0)}</div>
            </div>
            <div className="card-total">
              <span className="card-total-title card-total-title-primary"><i className="bi bi-credit-card card-total-icon"></i>Crédito</span>
              <span className="card-total-value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(totais.credito)}</span>
              <div className="card-total-tax">Taxa: {Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(taxas.CREDITO || 0)}</div>
            </div>

          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: 20 }}>

            <div className="card-total">
              <span className="card-total-title">Total Bruto</span>
              <span className="card-total-value" style={{ fontWeight: "bold", color: "#2b6cb0" }}>{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(totais.totalBruto)}</span>
              {/* <div className="card-total-tax">Taxa: {Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format((Number(taxas.PIX) || 0) + (Number(taxas.CREDITO) || 0) + (Number(taxas.DEBITO) || 0))}</div> */}
            </div>
            <div className="card-total">
              <span className="card-total-title">Total Estornos</span>
              <span className="card-total-value" style={{ fontWeight: "bold", color: "#ff4d4f" }}>{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(totais.estornos)}</span>

            </div>
            <div className="card-total">
              <span className="card-total-title">Prêmios entregues</span>
              <span className="card-total-value" style={{ fontWeight: "bold", color: "#805ad5" }}>{premiosEntregues}</span>
            </div>
            <div className="card-total">
              <span className="card-total-title">Total Taxas</span>
              <span className="card-total-value" style={{ fontWeight: "bold", color: "#ff4d4f" }}>- {Number((taxas.PIX + taxas.CREDITO + taxas.DEBITO).toFixed(2))}</span>
            </div>
            <div className="card-total">
              <span className="card-total-title">Total Líquido</span>
              <span className="card-total-value" style={{ fontWeight: "bold", color: "#28a745" }}>{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(totais.totalLiquido)}</span>

            </div>
            <div className="card-total">
              <span className="card-total-title">Estoque</span>
              <span className="card-total-value">{estoque}</span>
              <span className="card-total-title">Qtd. Vendas</span>
              <span className="card-total-value">{totais.quantidade}</span>
            </div>

          </div>
        </div>
      </div>

      {/* Tabela */}
      <div className="card" style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderRadius: '8px' }}>
        <div className="card-header">
          <h5>{`${maquinaInfos?.nome} - ${maquinaInfos?.descricao}`}</h5>
        </div>
        <div className="card-body">
          <PagamentosTable onRemove={removerPagamento} onExport={exportarPagamentoPdf} listCanals={listCanals} />
        </div>
      </div>
    </div>
  );
}
